export function debounce<Params extends any[]>(
  func: (...args: Params) => any,
  timeout: number
): (...args: Params) => void {
  let timer: NodeJS.Timeout
  return (...args: Params) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func(...args)
    }, timeout)
  }
}

export function throttle<Params extends any[]>(
  func: (...args: Params) => any,
  limit: number
): (...args: Params) => void {
  let waiting = false
  return (...args: Params) => {
    if (!waiting) {
      func(...args)
      waiting = true
      setTimeout(function () {
        waiting = false
      }, limit)
    }
  }
}
